const fabFootageEditorConfig = {
  initialContent: {
    title: "",
    videos_text: "",
  },

  loadContent(content = {}) {
    return {
      ...this.initialContent,
      ...content,

      videos_text: Array.isArray(content.videos)
        ? content.videos.join("\n")
        : content.videos_text || "",
    };
  },

  buildContent(templateState = {}) {
    return {
      title: templateState.title?.trim() || "",

      videos: templateState.videos_text
        ? templateState.videos_text
            .split("\n")
            .map((line) => line.trim())
            .filter(Boolean)
        : [],
    };
  },

  getStep2Props({
    templateState,
    setTemplateField,
  }) {
    return {
      templateState,
      setTemplateField,
    };
  },
};

export default fabFootageEditorConfig;